import request from "@/config/utils/request";

// 列表查询(新)
export function queryQuotationSeekPageForSupplier(data) {
  return request({
    url: "/apis/ebs/spc/seekPurchase/queryQuotationSeekPageForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 列表查询 20250815
export function querySeekPageForSupplierLists(data) {
  return request({
    // url: "/apis/ebs/spc/seekPurchase/querySeekPageForSupplier", // 后端接口
    url: "/apis/ebs/spc/seek/pageListEcQuote", // 后端接口
    method: "post",
    data
  });
}

// 详情查询（新的）20250814
export function queryNewSeekDetailForSupplier(data) {
  return request({
    // url: "/apis/ebs/spc/seekPurchase/queryNewestSeekDetailForSupplier", // 后端接口
    url: "/apis/ebs/spc/seek/queryNewestSeekDetailForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 详查询库存情况
export function querySeekSkuForSupplier(data) {
  return request({
    url: "/apis/ebs/spc/seek/querySeekSkuForSupplier", // 后端接口
    method: "post",
    data
  });
}

// 供应商报价
export function supplierQuote(data) {
  return request({
    url: "/apis/ebs/spc/seek/supplierQuote", // 后端接口
    method: "post",
    data
  });
}
// 供应商报名
export function supplierRegister(data) {
  return request({
    url: "/apis/ebs/spc/seek/supplierRegister", // 后端接口
    method: "post",
    data
  });
}

// 计算金额
export function getShowPrice(data) {
  return request({
    url: "/apis/ebs/spc/seek/getShowPrice",
    method: "post",
    data
  });
}

// 综合金计算金额
export function getShowFinalQuotePrice(data) {
  return request({
    url: "/apis/ebs/spc/seek/getShowFinalQuotePrice",
    method: "post",
    data
  });
}

// 查询同类商品
export function querySkuIsCheckList(data) {
  return request({
    url: "/apis/ebs/spc/seekPurchase/querySkuIsCheckList",
    method: "post",
    data
  });
}

// 查询同类商品
export function getShopSupplierList(data) {
  return request({
    url: `/apis/ebs/spc/seekPurchase/getShopSupplierList?supplierId=${data.supplierId}`,
    method: "post",
    data
  });
}
// 预览
export function filePreview(data) {
  return request({
    url: `/apis/ebs/file/filePreview`,
    method: "post",
    data
  });
}
